const handleSwiperImages = (swiperContainer) => {
    const rangeInput = swiperContainer.querySelector('.portfolio-swiper__portfolio--images-range');

    rangeInput.addEventListener("input", (e) => {
        const newValue = e.target.value / 2;
        swiperContainer.style.setProperty('--position', `${newValue}%`);
    })
}

export { handleSwiperImages };